import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import React from "react";

// eslint-disable-next-line import/no-unused-modules
export type TableProps = {
  header?: string | React.ReactNode;
  headers?: (string | React.ReactNode)[];
  tableLines: (React.ReactNode | null)[];
  headerClasses?: string[];
  headerClassName?: string;
  tableClassName?: string;
  tableWrapperClassName?: string;
};
export default function TableV2(t0) {
  const $ = _c(22);
  const {
    header,
    headers,
    tableLines,
    tableClassName,
    tableWrapperClassName,
    headerClasses,
    headerClassName
  } = t0;
  let t1;
  if ($[0] !== header) {
    t1 = header && <div className="table-main-header">{header}</div>;
    $[0] = header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tableWrapperClassName) {
    t2 = cn("w-full overflow-x-scroll", tableWrapperClassName);
    $[2] = tableWrapperClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tableClassName) {
    t3 = cn(tableClassName);
    $[4] = tableClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== headerClassName || $[7] !== headerClasses || $[8] !== headers) {
    t4 = headers && <thead className={headerClassName}><tr className="text-left">{headers.map((header_0, index) => <th key={`header-${index}`} className={headerClasses ? headerClasses[index] : ""}>{header_0}</th>)}</tr></thead>;
    $[6] = headerClassName;
    $[7] = headerClasses;
    $[8] = headers;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== tableLines) {
    t5 = tableLines && <tbody>{tableLines.filter(_temp).map(_temp2)}</tbody>;
    $[10] = tableLines;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <table className={t3}>{t4}{t5}</table>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <div className={t2}>{t6}</div>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t1 || $[20] !== t7) {
    t8 = <>{t1}{t7}</>;
    $[19] = t1;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp2(tableLine) {
  return tableLine;
}
function _temp(l) {
  return l !== null;
}